"use client";

import { useState, useEffect } from "react";
import "../../assets/css/dashborard.min.css";
import OverviewSection from "./sections/OverviewSection";


// Mock user data - in real app this would come from authentication context
const mockUser = {
    id: 1,
    name: "John Doe",
    email: "john.doe@example.com",
    avatar: "/placeholder.svg?height=40&width=40",
    role: "Administrator",
    department: "Engineering",
};

export default function Dashboard () {
    // Dashboard state management
    const [activeSection, setActiveSection] = useState("overview");
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    const [user] = useState(mockUser);

    // Handle responsive behavior
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 992) {
                setSidebarCollapsed(true);
            } else {
                setSidebarCollapsed(false);
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);




    return (
        <div className="dashboard-container">
            <div className={`dashboard-main ${sidebarCollapsed ? "sidebar-collapsed" : ""}`}>
                <div className="content-wrapper">
                    <OverviewSection searchQuery={searchQuery} user={user} />
                </div>
            </div>

            {/* Mobile Overlay */}
            {!sidebarCollapsed && window.innerWidth < 992 && (
                <div className="mobile-overlay" onClick={() => setSidebarCollapsed(true)} />
            )}
        </div>
    );
}
